import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const AiSparklesIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.18 0.7C5.34 2.42 6 3.08 7.72 3.24C6 3.4 5.34 4.06 5.18 5.78C5.02 4.06 4.36 3.4 2.64 3.24C4.36 3.08 5.02 2.42 5.18 0.7Z" />
            <path d="M2.1 3.86C2.21 4.94 2.61 5.34 3.69 5.45C2.61 5.56 2.21 5.97 2.1 7.05C1.99 5.97 1.58 5.56 0.5 5.45C1.58 5.34 1.99 4.94 2.1 3.86Z" />
            <path d="M7.69 5.67C7.81 6.9 8.27 7.36 9.5 7.49C8.27 7.61 7.81 8.07 7.69 9.3C7.56 8.07 7.1 7.61 5.87 7.49C7.1 7.36 7.56 6.9 7.69 5.67Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const AiSparklesIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.18 0.7C5.34 2.42 6 3.08 7.72 3.24C6 3.4 5.34 4.06 5.18 5.78C5.02 4.06 4.36 3.4 2.64 3.24C4.36 3.08 5.02 2.42 5.18 0.7Z" />
            <path d="M2.1 3.86C2.21 4.94 2.61 5.34 3.69 5.45C2.61 5.56 2.21 5.97 2.1 7.05C1.99 5.97 1.58 5.56 0.5 5.45C1.58 5.34 1.99 4.94 2.1 3.86Z" />
            <path d="M7.69 5.67C7.81 6.9 8.27 7.36 9.5 7.49C8.27 7.61 7.81 8.07 7.69 9.3C7.56 8.07 7.1 7.61 5.87 7.49C7.1 7.36 7.56 6.9 7.69 5.67Z" />
        </SvgIcon>
    );
};
